var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileNv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4142 5L10.4142 21H20.6C21.3732 21 22 21.6268 22 22.4V23.5858L37.7071 7.87868C37.8946 7.69114 38 7.43679 38 7.17157V5H26.4142ZM21.4185 26.9085C20.9065 27.5724 20.1032 28 19.2 28H15V36H19C20.6569 36 22 37.3431 22 39V40.5858L38 24.5858V22C38 21.4477 37.5523 21 37 21H34C32.3431 21 31 19.6569 31 18V17.4142L21.7071 26.7071C21.621 26.7932 21.523 26.8604 21.4185 26.9085ZM33 15.4142L39.1213 9.29289C39.6839 8.73028 40 7.96722 40 7.17157V4.4C40 3.6268 39.3732 3 38.6 3H26.1657C25.7944 3 25.4383 3.1475 25.1757 3.41005L7 21.5858V42.6C7 43.3732 7.6268 44 8.4 44H21.4142L39.59 25.8243C39.8525 25.5617 40 25.2056 40 24.8343V22C40 20.3431 38.6569 19 37 19H34C33.4477 19 33 18.5523 33 18V15.4142ZM20 42V39C20 38.4477 19.5523 38 19 38H13V26H19.2C19.6418 26 20 25.6418 20 25.2V23H9V42H20Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.7071 21.2929C31.0976 21.6834 31.0976 22.3166 30.7071 22.7071L18.7071 34.7071C18.3166 35.0976 17.6834 35.0976 17.2929 34.7071C16.9024 34.3166 16.9024 33.6834 17.2929 33.2929L29.2929 21.2929C29.6834 20.9024 30.3166 20.9024 30.7071 21.2929Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileNv);
export default __webpack_public_path__ + "static/media/Profile_nv.7d60cd7fad7c2165073f0650389b3fdb.svg";
export { ForwardRef as ReactComponent };